import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog';

export interface HelpHintProps {
  title?: React.ReactNode;
  content: React.ReactNode;
  tooltip?: React.ReactNode;
  icon?: React.ReactNode;
  placement?: 'top' | 'bottom' | 'left' | 'right';
  className?: string;
}

export const HelpHint: React.FC<HelpHintProps> = ({
  title,
  content,
  tooltip,
  icon = '❔',
  placement = 'top',
  className
}) => {
  const { t } = useTranslation('components');

  const resolvedTitle = title ?? t('helpHint.title');
  const resolvedTooltip = tooltip ?? t('helpHint.tooltip');
  const ariaLabel = t('helpHint.ariaLabel');

  return (
    <span className={className}>
      <Dialog>
        <Tooltip>
          <DialogTrigger asChild>
            <TooltipTrigger asChild>
              <Button size="sm" variant="ghost" aria-label={ariaLabel} className="leading-none">
                {icon}
              </Button>
            </TooltipTrigger>
          </DialogTrigger>
          <TooltipContent side={placement}>{resolvedTooltip}</TooltipContent>
        </Tooltip>

        <DialogContent>
          <DialogHeader>
            {resolvedTitle && <DialogTitle>{resolvedTitle}</DialogTitle>}
          </DialogHeader>
          <div className="text-sm leading-relaxed">{content}</div>
        </DialogContent>
      </Dialog>
    </span>
  );
};

